import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { getItemFromArray } from "../../components/Common";
import * as BSL_Common from "../../components/BSL_CommonControls";
import BSL_Button from "../../components/BSL_Button";
import BSL_Dialog from "../../components/BSL_Dialog";
import { ListSubheader } from "@material-ui/core";
import * as APP from "../../redux_store/appState";
import { ClearScratch } from "../../components_designer/layout/PaperDesigner";
import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";
import BSL_Select from "../../components/BSL_Select";
import {
    updateAreaSpecification,
    updateAreaSpecificationModificationArray,
    deleteFromAreaSpecificationModificationArray,
} from "../../redux_store/jobState";
import BSL_TextInput from "../../components/BSL_TextInput";
import BSL_CheckBox from "../../components/BSL_CheckBox";

const useStyles = makeStyles({
    root: {},
});

export default function SpecExtraBeamDialog(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const app = useSelector((state) => state.app);
    const job = useSelector((state) => state.job);
    const config = useSelector((state) => state.config);
    const { areaIndex, showButtons = true, edit_item } = props;

    let edit_beam = null;
    if (edit_item?.ref5) {
        if (areaIndex > -1 && job.AreaSpecifications[areaIndex]?.NewBeams) {
            edit_beam = getItemFromArray(job.AreaSpecifications[areaIndex]?.NewBeams, "Ref", edit_item.ref5);
        } else {
            for (var this_areaIndex in job.AreaSpecifications) {
                areaIndex = Number(this_areaIndex);
                edit_beam = getItemFromArray(job.AreaSpecifications[areaIndex].NewBeams, "Ref", edit_item.ref5);
                if (edit_beam) break;
            }
        }
    }

    const AREA_INDEX = app.designer.designer2D?.[APP.AREA_INDEX];
    const area_design_specs = job?.AreaSpecifications?.[areaIndex];
    const designType = area_design_specs.SHAPE.DesignType;
    const area_config = config?.design_options?.[designType];
    const beam_types = config.beam_types;
    const SELECTED_POINTS = app.designer.designer2D[APP.SELECTED_POINT];
    const SELECT_POINT = app.designer.designer2D[APP.SELECT_POINT];
    const BeamPostParameters = area_design_specs?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS];
    const [beamSelection, setBeamSelection] = React.useState(
        edit_beam?.Section ? edit_beam?.Section : BeamPostParameters.BeamType1
    );
    const [beamName, setBeamName] = React.useState(edit_beam?.Name ? edit_beam?.Name : "");
    const [snap, setSnap] = React.useState(edit_beam?.Snap ? edit_beam?.Snap : 1);
    const [fixedHeight, setFixedHeight] = React.useState(edit_beam?.FixedHeight ? edit_beam?.FixedHeight : 0);

    const [showNewBeamDialog, setShowNewBeamDialog] = React.useState(false);
    const [waitingForPoints, setWaitingForPoints] = React.useState(false);
    const [loaded, setLoaded] = React.useState(false);
    // const rows = useSelector(state => state.app.user_last_jobs_edited);

    React.useEffect(() => {
        if (!loaded) return;
        if (waitingForPoints && SELECTED_POINTS) {
            setWaitingForPoints(false);
            dispatch(APP.update2DDesigner(APP.SELECT_POINT, 0));
            setShowNewBeamDialog(true);
        }
        // if (AREA_INDEX === areaIndex && !SELECTED_POINTS) {
        //     setWaitingForPoints(false);
        //     dispatch(APP.setDesignerLoadingBackdrop("Loading Full Layout..."));
        //     dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, false));
        //     dispatch(APP.update2DDesigner(APP.AREA_INDEX, -1));
        // }
    }, [SELECTED_POINTS]);

    React.useEffect(() => {
        if (AREA_INDEX !== areaIndex && job.AreaSpecifications.length > 1) return;
        if (!loaded) return;
        if (SELECT_POINT === false) {
            setWaitingForPoints(false);
            dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, false));
            if (job?.AreaSpecifications?.length > 1) {
                dispatch(APP.setDesignerLoadingBackdrop("Loading Full Layout..."));
                dispatch(APP.update2DDesigner(APP.AREA_INDEX, -1));
            }
        }
    }, [SELECT_POINT]);

    const getBeamPoints = () => {
        setWaitingForPoints(true);
        ClearScratch();
        if (job.AreaSpecifications.length > 1) {
            dispatch(APP.setDesignerLoadingBackdrop("Loading Area " + (areaIndex + 1) + " Layout..."));
            dispatch(APP.update2DDesigner(APP.AREA_INDEX, areaIndex));
        }
        dispatch(
            APP.update2DDesigner(
                APP.SELECT_POINT_NOTE,
                <>
                    First, click a point for the start of a beam (on an attachment or existing beam).
                    <br />
                    Next, click where you would like to end the beam (on an attachment or existing beam)
                    <br />
                    *Right click or press 'ESC' to cancel.
                </>
            )
        );
        // dispatch(APP.updateLayout2D(null, areaIndex));
        dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, true));
        dispatch(APP.update2DDesigner(APP.SELECT_POINT, 2));
        dispatch(APP.update2DDesigner(APP.SELECT_POINT_ALLOW_HIT_SELTYPE, "dimension"));
        // dispatch(update2DDesigner(APP.SELECTED_POINT, {x: 0, y: 0}));
    };

    const wipeExtraBeams = () => {
        dispatch(updateAreaSpecification(AREA_INDEX > -1 ? AREA_INDEX : areaIndex, "NewBeams", null, []));
    };

    const onClose = () => {
        if (!edit_item) {
            ClearScratch();
            setShowNewBeamDialog(false);
            setWaitingForPoints(true);
            dispatch(APP.update2DDesigner(APP.SELECT_POINT, 2));
        }

        if (props.onClose) {
            props.onClose();
        }
    };
    if (!loaded) setLoaded(true);

    let beam1_menu_items = [];

    const beam1 = area_config.beam_1;
    if (beam1) {
        for (let key in beam1.options) {
            if (beam1.options?.[key]) beam1_menu_items.push(<ListSubheader key={key}>{key}</ListSubheader>);
            if (beam1.options?.[key])
                for (let key2 of beam1.options[key]) {
                    const beam = beam_types?.[key2];
                    if (beam)
                        beam1_menu_items.push({
                            Key: beam.id ? beam.id : key2,
                            Display: beam.name ? beam.name : key2,
                            Thumbnail: beam.thumbnail,
                        });
                }
        }
    }

    return (
        <>
            {showButtons && (
                <BSL_Common.SectionRow style={{ paddingTop: "12px" }}>
                    <BSL_Button
                        style={{ marginLeft: "8px", alignSelf: "center", width: "60%" }}
                        onClick={getBeamPoints}
                        disabled={app.designer.threeDMode && !app.designer.threeDMiniMode}
                    >
                        Add Extra Beam {waitingForPoints}
                    </BSL_Button>
                    <BSL_Button
                        secondary
                        style={{ marginLeft: "8px", alignSelf: "center", flex: 1 }}
                        onClick={wipeExtraBeams}
                    >
                        Wipe All (Area)
                    </BSL_Button>
                </BSL_Common.SectionRow>
            )}

            <BSL_Dialog
                title={edit_item ? "Edit Extra Beam" : "Add New Beam"}
                open={showNewBeamDialog || edit_item}
                onClose={onClose}
                button1Text={edit_item ? "Edit Beam" : "Save Beam"}
                button1Click={() => {
                    onClose();

                    let new_beam = {};

                    if (edit_beam) {
                        new_beam = {
                            ...edit_beam,
                            Section: beamSelection,
                            Name: beamName,
                            Snap: snap,
                            FixedHeight: fixedHeight,
                        };
                    } else {
                        let p1 =
                            "(" + SELECTED_POINTS[0].x.toFixed(2) + "," + SELECTED_POINTS[0].y.toFixed(2) + ",0.00)";
                        let p2 =
                            "(" + SELECTED_POINTS[1].x.toFixed(2) + "," + SELECTED_POINTS[1].y.toFixed(2) + ",0.00)";
                        let ref = p1 + ";" + p2;

                        new_beam = {
                            Ref: ref,
                            P1: p1,
                            P2: p2,
                            Section: beamSelection,
                            Snap: snap,
                            Offset1: -1,
                            Offset2: -1,
                            From1Side1: 0,
                            From1Side2: 0,
                            FixedHeight: fixedHeight,
                            Name: beamName,
                        };
                    }
                    dispatch(
                        updateAreaSpecificationModificationArray(
                            AREA_INDEX > -1 ? AREA_INDEX : areaIndex,
                            "NewBeams",
                            new_beam.Ref,
                            null,
                            new_beam,
                            true
                        )
                    );
                }}
                button2Text="Cancel"
                button2Click={onClose}
                button3Text={edit_beam ? "Delete Beam" : null}
                button3Click={() => {
                    onClose();
                    dispatch(
                        deleteFromAreaSpecificationModificationArray(
                            AREA_INDEX > -1 ? AREA_INDEX : areaIndex,
                            "NewBeams",
                            edit_beam.Ref
                        )
                    );
                }}
            >
                <BSL_TextInput
                    label="Beam Name"
                    placeholder="eg; Extra Rafter"
                    value={beamName}
                    onBlur={(val) => {
                        setBeamName(val);
                    }}
                />
                <BSL_Select
                    label="Beam Type"
                    // selectStyle={{ background: "#fff" }}
                    value={beamSelection}
                    items={beam1_menu_items}
                    onChange={(e) => setBeamSelection(e.target.value)}
                />
                <BSL_TextInput
                    label="Fixed Height, Bottom of Beam from FFL"
                    placeholder="Auto"
                    value={fixedHeight}
                    min={0}
                    max={4000}
                    endAdornment="mm"
                    helperText="set to 0 to automatically determine the height."
                    inputPropsStyle={{
                        width: "80px",
                    }}
                    onChange={(val) => setFixedHeight(val)}
                />
                <BSL_CheckBox
                    checked={snap}
                    returnInt
                    label="Snap Beam to Right Angles (if close)"
                    onChange={(val) => setSnap(val)}
                />
            </BSL_Dialog>
        </>
    );
}

// NumNewBeams=1
// _1_P1=(1136.00,1807.50,0.00)
// _1_P2=(1638.00,32.50,0.00)
// _1_Section=1586510
// _1_Offset1=1136
// _1_Offset2=1638
// _1_From1Side1=0
// _1_From1Side2=1
